// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.
import { RiskStocks, RiskTemplate } from '@advisor-app/features/risk';
import { type AssetsInfoResp } from '@shared/data-access/interfaces/api/ai/assets';
import {
  type PortfolioAnalysis,
  type StockAnalysis,
} from '@shared/data-access/interfaces/api/ai/portfolio-analysis';
import { type WorkflowAsset } from '@shared/data-access/interfaces/redux/workflow-state';
import { ThermometerGraph } from '@shared/ui-kit/components';
import { type FC } from 'react';

export interface RiskProps {
  assetType: WorkflowAsset;
  analysis: PortfolioAnalysis;
  assetsInfo: AssetsInfoResp[];
}

export const Risk: FC<RiskProps> = ({ assetType, analysis, assetsInfo }) => {
  return (
    <div>
      <div className="grid grid-cols-4 gap-x-6">
        <ThermometerGraph
          type="valueRisk"
          value={analysis?.var?.value?.at(94) ?? 0}
        />
        <ThermometerGraph
          type="volatility"
          value={analysis?.risk?.volatility ?? 0}
        />
        <ThermometerGraph type="sharpe" value={analysis?.risk?.sharpe ?? 0} />
        <ThermometerGraph type="beta" value={analysis?.risk?.beta ?? 0} />
      </div>

      {assetType === 'stock' ? (
        <RiskStocks analysis={analysis as StockAnalysis} assetsInfo={assetsInfo} />
      ) : (
        <RiskTemplate analysis={analysis} assetsInfo={assetsInfo} />
      )}
    </div>
  );
};
